import { render } from "./Categories.vue?vue&type=template&id=17333d2b&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=17333d2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17333d2b"]])

export default __exports__